module.exports = __webpack_public_path__ + "img/logo.ccf1be6d.png";